import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { 
  Modal, 
  Typography, 
  Backdrop, 
  Fade,
  Button
} from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 3, 2),
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  spacer: {
    flexGrow: 1
  },
  finishButton: {
    marginLeft: theme.spacing(1)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
}))

const ExModalHide = props => {
  const { open, onClose, onHide, isShow = true } = props
  const classes = useStyles()

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <Typography
            className={classes.title}
            variant="h4"
          >
            Konfirmasi {isShow ? 'Sembunyikan' : 'Tampilkan'} Ulasan
          </Typography>
          <Typography
            variant="subtitle1"
          >
            Apakah anda yakin {isShow ? 'menyembunyikan' : 'menampilkan'} ulasan produk ini?
          </Typography>
          <div className={classes.row}>
            <span className={classes.spacer} />
            <Button
              color="primary"
              variant="outlined"
              onClick={onClose}
            >
              Batal
            </Button>
            <Button
              color="primary"
              variant="contained"
              className={classes.finishButton}
              onClick={onHide}
            >
              Setuju
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}

ExModalHide.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  isShow: PropTypes.bool
}

export default ExModalHide
